const AccessKeyId = process.env.REACT_APP_ACCESS_KEY_ID
const SecretAccessKey = process.env.REACT_APP_SECREATE_ACCESS_KEY
const Region = process.env.REACT_APP_REGION

var AWS = require('aws-sdk');
var accessKeyId = AccessKeyId;
var secretAccessKey = SecretAccessKey;
var region = Region;  //Singapoor region by default
var spacesEndpoint = new AWS.Endpoint(region + '.digitaloceanspaces.com');

var bucketName = 'static-ethics';
const albumPhotosKey = "etm/";

// const CommonFileURL = "https://static-ethics.sgp1.digitaloceanspaces.com";   // privious common url for display images/files
const CommonFileURL = "https://static-ethics.sgp1.cdn.digitaloceanspaces.com";  // common url for display images/files
const FolderName = "etm";                                                       // main folder name (change according project)
export const CommonFileURLWithFolder = `${CommonFileURL}/${FolderName}/`;

export async function ImageUpload(pathdire, imagename, image) {
    let isUploaded = true;
    var s3 = new AWS.S3({
        endpoint: spacesEndpoint,
        accessKeyId: accessKeyId,
        secretAccessKey: secretAccessKey
    });


    const photoKey = albumPhotosKey + pathdire + imagename;

    var params = {
        ACL: 'public-read',
        Bucket: bucketName,
        Key: photoKey,
        Body: image
    };
    await s3.putObject(params)
        .promise()
        .then(res => {
            console.log(`Upload succeeded - `, res);
            isUploaded = true;
            return true;
        })
        .catch(err => {
            console.log("Upload failed:", err);
            isUploaded = false;
            return false;
        });

    return isUploaded;
}

export async function ImageDelete(imagePath) {
    let isDeleted = true;
    var s3 = new AWS.S3({
        endpoint: spacesEndpoint,
        accessKeyId: accessKeyId,
        secretAccessKey: secretAccessKey
    });
    const photoKey = albumPhotosKey + imagePath;

    var params = {
        Bucket: bucketName,
        Key: photoKey
    };
    await s3.deleteObject(params)
        .promise()
        .then((data) => {
            console.log('sucessfully deleted ' + imagePath, data)
            isDeleted = true;
        })
        .catch((err) => {
            console.log('err: ', err)
            isDeleted = false;
        });

    return isDeleted;
}
